<template>
  <div class="auth-container">
    <div v-if="!codeSent" class="form-step">
      <p class="h5 text-justify mb-3" style="margin-top: 15px">Vor der Verwendung der App müssen wir prüfen, ob Sie
        Angehörige oder Angehöriger der RWTH Aachen oder der Uniklinik RWTH Aachen sind. Bitte geben Sie hierzu Ihre
        E-Mailadresse ein.</p>
      <p class="h5 text-justify mb-3" style="margin-top: 15px">Wir speichern die Anmeldung am System und ihre
        E-Mailadresse für maximal 24 Monate. Die weiteren Eingaben in dem System werden nicht gespeichert.</p>
      <p class="h5 text-justify mb-3" style="margin-top: 15px">Sie erhalten eine Email mit einem Bestätigungscode. Mit
        diesem Schritt bestätigen Sie, dass Sie das System nicht in der Patientenversorgung einsetzen und die
        Informationen aus dem System nicht für medizinische Entscheidungen verwenden werden.</p>
      <input
          v-model="email"
          type="email"
          placeholder="Enter your university/hospital email"
      />
      <button @click="sendCode">Send Code</button>
    </div>

    <div v-else class="form-step">
      <input
          v-model="code"
          type="text"
          placeholder="Enter verification code"
      />
      <button @click="verifyCode">Verify</button>
    </div>

    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      code: '',
      codeSent: false,
      message: '',
      token: ''
    };
  },
  methods: {
    async sendCode() {
      try {
        const res = await fetch('/api/send-code', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({email: this.email})
        });
        const data = await res.json();
        this.codeSent = res.ok;
        this.message = data.message || (res.ok ? 'Code sent!' : 'Error sending code');
      } catch (err) {
        this.message = 'Network error, please try again.';
      }
    },
    async verifyCode() {
      try {
        const res = await fetch('/api/verify-code', {   // 🔥 changed here
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({email: this.email, code: this.code})
        });
        const data = await res.json();
        this.message = data.message || (res.ok ? 'Verified!' : 'Invalid code');
        if (res.ok && data.token) {
          this.token = data.token;
          localStorage.setItem('jwt', data.token);
          alert('✅ Access granted! You can now use the app.');
          await this.$router.push('/secure');
        }
      } catch (err) {
        this.message = 'Network error, please try again.';
      }
    }
  }
};
</script>

<style scoped>
.auth-container {
  max-width: 750px;
  margin: 2rem auto;
  padding: 1rem;
  border: 1px solid #CCCCCC;
  border-radius: 8px;
}

.form-step {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

input {
  padding: 0.5rem;
  border: 1px solid #aaa;
  border-radius: 4px;
}

button {
  padding: 0.5rem;
  background: #2c7be5;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background: #1a5bb8;
}

p {
  margin-top: 1rem;
}
</style>